import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customer-reviews-bar" }
const _hoisted_2 = { class: "customer-reviews-bar__header" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["aria-label", "aria-valuenow", "aria-valuemax"]

import { RATING_MAX_VALUE } from '@global-js/constants';
import { computed } from 'vue';

interface Props {
	value: number;
	maxValue?: number;
	title?: string;
	rating?: string;
	arialabelSuffix?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerReviewsBar',
  props: {
    value: {},
    maxValue: { default: () => (RATING_MAX_VALUE) },
    title: {},
    rating: {},
    arialabelSuffix: { default: 'Bewertung' }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "241deb22": (progressStyle.value)
}))



const currentValue = computed(() => Math.max(0, Math.min(__props.value, __props.maxValue)));

const progressStyle = computed(() => {
	const percentage = Math.floor((currentValue.value / __props.maxValue) * 100);
	return `${percentage}%`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("dt", _hoisted_2, [
      _createElementVNode("span", {
        class: "customer-reviews-bar__header-title",
        textContent: _toDisplayString(_ctx.title)
      }, null, 8 /* PROPS */, _hoisted_3),
      _createElementVNode("span", {
        class: "customer-reviews-bar__header-rating",
        textContent: _toDisplayString(_ctx.rating)
      }, null, 8 /* PROPS */, _hoisted_4)
    ]),
    _createElementVNode("div", {
      role: "progressbar",
      "aria-label": `${_ctx.title} ${_ctx.arialabelSuffix}`,
      class: "customer-reviews-bar__progress",
      "aria-valuenow": _ctx.value,
      "aria-valuemin": "0",
      "aria-valuemax": _ctx.maxValue
    }, null, 8 /* PROPS */, _hoisted_5)
  ]))
}
}

})